import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { authenticated, hasRole, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Log user info for debugging
  console.log('Protected Route - User:', user);
  console.log('Protected Route - Required Role:', requiredRole);
  console.log('Protected Route - Has Role:', hasRole(requiredRole));

  // During development, you might want to bypass role check
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (requiredRole && !hasRole(requiredRole) && !isDevelopment) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;